import { Dispatch, SetStateAction } from 'react'
import * as yup from 'yup'
import { Affiliate } from 'types'

export type FormData = {
  email: string
}

export type ContactEmailProps = {
  affiliate: Affiliate
  updateLor?: boolean
  update?: (newValue) => void
  setIsEditing?: Dispatch<SetStateAction<boolean>>
}

export const schema = yup
  .object()
  .shape({
    email: yup.string().required('Contact email is required'),
  })
  .required()
